(function(){
  "use strict";
  var stage = document.querySelector("[data-gw-drop-at]");
  if(!stage) return;
  var target = Date.parse(stage.getAttribute("data-gw-drop-at"));
  if(isNaN(target)) return;

  var d = stage.querySelector("[data-gw-d]"),
      h = stage.querySelector("[data-gw-h]"),
      m = stage.querySelector("[data-gw-m]"),
      s = stage.querySelector("[data-gw-s]");
  if(!d || !h || !m || !s) return;

  var timer = null;
  function pad(n){ return n < 10 ? "0" + n : "" + n; }

  function paint(){
    var left = target - Date.now();
    if(left <= 0){
      stage.setAttribute("data-gw-drop-state","live");
      if(timer){ clearInterval(timer); timer = null; }
      return;
    }
    var sec = Math.floor(left / 1000);
    d.textContent = pad(Math.floor(sec / 86400));
    h.textContent = pad(Math.floor(sec / 3600) % 24);
    m.textContent = pad(Math.floor(sec / 60) % 60);
    s.textContent = pad(sec % 60);
    stage.setAttribute("data-gw-hydrated","");
  }

  paint();
  if(Date.now() < target){ timer = setInterval(paint, 1000); }
  document.addEventListener("visibilitychange", function(){ if(!document.hidden) paint(); });
})();
